import script from "./aboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutUs.vue?vue&type=script&setup=true&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=2e7ac27e&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7ac27e"]])

export default __exports__